import React, { useState } from "react";
import { auth, RecaptchaVerifier, signInWithPhoneNumber, db } from "../firebase";
import { doc, setDoc, getDocs, query, collection, where } from "firebase/firestore";
import { X } from "lucide-react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Danh sách avatar mặc định
const defaultAvatars = [
  "https://firebasestorage.googleapis.com/v0/b/nhontrach-today.firebasestorage.app/o/avatars%2F11.png?alt=media&token=c6549ebc-2b6a-4bea-9a64-9e31247db0bb",
  "https://firebasestorage.googleapis.com/v0/b/nhontrach-today.firebasestorage.app/o/avatars%2F12.png?alt=media&token=d76da3be-0cfa-46a5-92d9-82a27aad0bfc",
  "https://firebasestorage.googleapis.com/v0/b/nhontrach-today.firebasestorage.app/o/avatars%2F13.png?alt=media&token=bc2af1c9-bd04-49e4-9b24-560064b9aefe",
  // ... (các avatar khác giữ nguyên như code bạn đưa)
];

function getRandomDefaultAvatar() {
  return defaultAvatars[Math.floor(Math.random() * defaultAvatars.length)];
}

export default function PhoneLoginPopup({ onClose }) {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmation, setConfirmation] = useState(null);
  const [loading, setLoading] = useState(false);

  // Hàm tạo profile nếu chưa có
  const createUserProfileIfNeeded = async (user) => {
    const phoneNumber = user.phoneNumber;
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("phone", "==", phoneNumber));
    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      console.log("User đã tồn tại, không tạo mới.");
      return;
    }

    const newUserId = user.uid;
    const randomName = `Khách ${Math.floor(1000000 + Math.random() * 9000000)}`;

    await setDoc(doc(db, "users", newUserId), {
      email: null,
      id: newUserId,
      name: randomName,
      newPostNotification: true,
      powerOutageNotification: true,
      systemNotification: true,
      phone: phoneNumber,
      pushToken: null,
      type: 0,
      avatarUrl: getRandomDefaultAvatar(),
    });

    console.log("Đã tạo mới user:", randomName);
  };

  const sendOtp = async () => {
    try {
      setLoading(true);

      if (!phone || phone.length < 8) {
        alert("Số điện thoại không hợp lệ!");
        setLoading(false);
        return;
      }

      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        { size: "invisible" }
      );

      const confirmationResult = await signInWithPhoneNumber(
        auth,
        `+${phone}`, // react-phone-input-2 đã trả về số kèm mã quốc gia (ví dụ: 84901234567)
        window.recaptchaVerifier
      );
      setConfirmation(confirmationResult);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    try {
      setLoading(true);
      const result = await confirmation.confirm(otp);
      const user = result.user;

      await createUserProfileIfNeeded(user);
      onClose();
    } catch (err) {
      alert("OTP sai hoặc đã hết hạn!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-6 relative">
        {/* Nút đóng */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          onClick={(e) => {
            e.stopPropagation(); // chặn click lan lên post item
            onClose();
          }}
        >
          <X size={20} />
        </button>

        {/* Tiêu đề */}
        <h3 className="text-xl font-semibold mb-4 text-gray-800 text-center">
          {confirmation ? "Nhập mã OTP" : "Đăng nhập bằng Số điện thoại"}
        </h3>

        {/* Form nhập */}
        {!confirmation ? (
          <>
            <div className="mb-3">
              <PhoneInput
                country={"vn"}
                value={phone}
                onChange={(value) => setPhone(value)}
                inputStyle={{
                  width: "100%",
                  height: "42px",
                  borderRadius: "8px",
                }}
                buttonStyle={{
                  borderRadius: "8px 0 0 8px",
                }}
              />
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation(); // chặn click lan lên post item
                sendOtp();
              }}
              disabled={loading || !phone}
              className="w-full bg-vietnam-primary hover:bg-vietnam-dark text-white font-medium py-2 rounded-lg transition disabled:bg-gray-400"
            >
              {loading ? "Đang gửi..." : "Gửi OTP"}
            </button>
          </>
        ) : (
          <>
            <input
              type="text"
              placeholder="Nhập OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 mb-3"
            />
            <button
              onClick={(e) => {
                e.stopPropagation(); // chặn click lan lên post item
                verifyOtp();
              }}
              disabled={loading || !otp}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 rounded-lg transition disabled:bg-gray-400"
            >
              {loading ? "Đang xác nhận..." : "Xác nhận"}
            </button>
          </>
        )}

        {/* Recaptcha container */}
        <div id="recaptcha-container"></div>
      </div>
    </div>
  );
}
